import { NgModule } from '@angular/core';
import { IrisCommonModule } from '../common/common.module';
import { FilesPreviewModalComponent } from './components/files-preview-modal/files-preview-modal.component';
import { IrisFilePreviewThumbnailComponent } from './components/file-preview-thumbnail/file-preview-thumbnail.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { IrisSimpleLoaderModule } from '@iris/common/modules/iris-simple-loader/simple-loader.module';
import { PinchZoomModule } from '@iris/common/modules/preview-file/components/pinch-zoom/pinch-zoom.module';
import { SafeResourceUrlPipe } from '../pipes-common/pipes';
import {
  SkModalContentComponent,
  StrakitButtonPrefixDirective
} from '@ngx-strakit/cdk';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { RouterLink } from '@angular/router';

@NgModule({
  imports: [
    IrisCommonModule,
    SkModalContentComponent,
    NgxExtendedPdfViewerModule,
    IrisSimpleLoaderModule,
    PinchZoomModule,
    SafeResourceUrlPipe,
    StrakitButtonPrefixDirective,
    StrakitButtonComponent,
    RouterLink,
  ],
  declarations: [
    FilesPreviewModalComponent,
    IrisFilePreviewThumbnailComponent,
  ],
  exports: [
    FilesPreviewModalComponent,
    IrisFilePreviewThumbnailComponent,
  ],
})
export class IrisPreviewFileModule {
}
